import React, { useState } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../components/auth/useAuth";
import { Link } from "react-router-dom";
import Version from "../../version";

const clientCredentials = {};

export default function Login() {
    const { t } = useTranslation();
    const [islogging, setIslogging] = useState(false);
    const { loginClient } = useAuth();

    const [showForm, setShowForm] = useState(false);

    const [showPassword, setShowPassword] = useState(false)

    const handleToggleForm = () => {
        setShowForm(!showForm)
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIslogging(true)
        setShowForm(!showForm)
        await loginClient(clientCredentials)
        setIslogging(false)
    };

    return (
        <Container className="login vh-100 d-flex align-items-center px-4">
            <Row className="px-4">
                <Container className="text-center">
                    <Row className="mb-5">
                        <Col>
                            <img
                                src="/images/logotipo-rumiantec-cabecera.png"
                                alt="Logotipo Rumiantec"
                                style={{ width: "100%" }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h1>{t("signin.welcome")}</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>{t("signin.paragraph")}</Col>
                    </Row>
                    <Row className="mt-3">
                        <Col>
                            <Button
                                variant="secondary"
                                className="w-100"
                                onClick={handleToggleForm}
                            >
                                    {t("signin.signin")}
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Version />
                        </Col>
                    </Row>
                </Container>
            </Row>

            {/* Overlay */}
            {showForm && <div className="overlay" onClick={handleToggleForm}></div>}

            {/* Sliding form */}
            <div className={`sliding-form ${showForm ? "show" : ""}`}>
                <Form className="formulario" onSubmit={handleSubmit}>
                    <Container fluid className="p-5">
                        <Row>
                            <Col className="text-center">
                                <h2 className="mb-4 font-general">{t("signin.signin")}</h2>
                            </Col>
                        </Row>
                        <Row className="my-3">
                            <Col>
                                <Form.Label htmlFor="login_email">
                                    {t("signin.email")}
                                </Form.Label>
                                <Form.Control
                                    name="login_email"
                                    className="login"
                                    type="email"
                                    autoComplete="off"
                                    onChange={(e) =>
                                        (clientCredentials.email = e.target.value)
                                    }
                                    tabIndex="1"
                                />
                            </Col>
                        </Row>
                        <Row className="my-3">
                            <Col>
                                <div className="d-flex justify-content-between">
                                    <Form.Label htmlFor="login_password">
                                        {t("signin.password")}
                                    </Form.Label>
                                    <Link
                                        to={`/${t("url.auth.forgotpassword")}`}
                                        className="link"
                                        tabIndex="3"
                                    >
                                        {t("signin.passwordforgoten")}
                                    </Link>
                                </div>
                                <Form.Control
                                    name="login_password"
                                    className="login"
                                    type={showPassword ? 'text' : 'password'}
                                    autoComplete="off"
                                    onChange={(e) =>
                                        (clientCredentials.password = e.target.value)
                                    }
                                    tabIndex="2"
                                />
                                <i className={`fas fa-eye${showPassword ? '-slash' : ''} sd-eye`} onClick={() => setShowPassword(!showPassword)}></i>
                            </Col>
                        </Row>
                        <Row className="my-3">
                            <Col>
                                <Button
                                    variant="primary"
                                    type="submit"
                                    className="w-100 my-2"
                                    tabIndex="4"
                                >
                                    {islogging ? (
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    ) : (
                                        t("signin.login")
                                    )}
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </Form>
            </div>
        </Container>
    );
}
